<template>
  <div v-if="item">
    <v-dialog
      ref="dialog"
      v-model="modal2"
      :return-value.sync="item.ValorAlfa"
      persistent
      max-width="1600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <label v-show="$vuetify.breakpoint.xsOnly">{{
          $vuetify.breakpoint.xsOnly ? item.Label : ""
        }}</label>
        <v-text-field
          v-model="item.ValorAlfa"
          :label="$vuetify.breakpoint.xsOnly ? '' : item.Label"
          :append-outer-icon="item.Auditoria === 'S' ? 'mdi-archive' : ''"
          @click:append-outer="AuditoriaDato(item)"
          :error="item.ErrorCampo"
          :error-messages="item.ErrorCampo ? [item.MensajeError] : ''"
          prepend-icon="mdi-map-marker-multiple"
          readonly
          v-bind="attrs"
          v-on="on"
          :readonly="item.Protegido"
        ></v-text-field>
      </template>

      <v-card>
        <v-toolbar dark color="#B6332E">
          <v-btn
            icon
            dark
            @click="
              modal2 = false;
              clear();
            "
          >
            <v-icon>mdi-close </v-icon>
          </v-btn>
          <v-toolbar-title
            ><v-icon left>mdi-map-marker-multiple</v-icon> Dirección Anterior:
            {{ item.ValorAlfa }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              class="d-none d-md-block"
              dark
              text
              @click="
                modelSelected.completo != '' &&
                modelSelected.completo != null &&
                modelSelected.completo != undefined
                  ? (item.ValorAlfa = modelSelected.completo)
                  : (item.ValorAlfa = modelSelected.complementocompleto);
                $refs.dialog.save(item.ValorAlfa);
                clear();
              "
              >Guardar</v-btn
            >
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container fluid>
            <v-row align="center" justify="start" v-if="item.Tipo == 15">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h3 mb-1">
                    <b>Ingreso de dirección: </b>
                  </v-list-item-title>
                  <span class="text-h5 mb-1">
                    Ingrese la dirección (de acuerdo al ejemplo) y de clic sobre
                    el botón <b>Guardar</b>.
                    <i
                      >(Diligencie los campos requeridos que identifiquen la
                      dirección a ingresar. Los campos que no requiera los puede
                      dejar en blanco. Puede ir verificando en el recuadro
                      inferior "Dirección Generada" su dirección)</i
                    >.</span
                  >
                </v-list-item-content>
              </v-list-item>
              <v-col cols="12" sm="12" md="12">
                <div class="text-center">
                  <v-chip
                    label
                    color="primary"
                    text-color="white"
                    value="Vía Principal"
                  >
                    <v-avatar left>
                      <v-icon>mdi-map</v-icon>
                    </v-avatar>
                    <b> VÍA PRINCIPAL </b>
                  </v-chip>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on }">
                    <v-autocomplete
                      v-model="modelSelected.prefijo"
                      :items="Prefijo"
                      item-value="Valor"
                      item-text="Descripcion"
                      color="primary"
                      @change="direccioncompleta()"
                      clearable
                      dense
                      :label="'Prefijo:'"
                      :hint="'Elija uno de los prefijos de la dirección:'"
                      v-on="on"
                    >
                    </v-autocomplete>
                  </template>
                  <span>Cra. - Carrera</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-tooltip top color="#B6332E">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :label="'Número'"
                      type="tel"
                      v-on:keypress="isNumber()"
                      v-model.number="modelSelected.numero1"
                      :maxlength="4"
                      :counter="4"
                      @input="direccioncompleta()"
                      :rules="[rules.max(4, modelSelected.numero1)]"
                      :hint="'Ingrese solo números'"
                      clearable
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <span>84</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="modelSelected.letra1"
                      label="Letra"
                      @input="direccioncompleta()"
                      :rules="[rules.max(15, modelSelected.letra1)]"
                      :maxlength="15"
                      :counter="15"
                      clearable
                      scrollable
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <span>B</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-tooltip top color="#B6332E">
                  <template v-slot:activator="{ on }">
                    <v-autocomplete
                      v-model="modelSelected.prefijo2"
                      :items="Prefijo2"
                      item-value="Valor"
                      item-text="Descripcion"
                      color="primary"
                      @change="direccioncompleta()"
                      clearable
                      dense
                      :label="'Caracteristica dirección:'"
                      :hint="'Elija uno de los prefijos de la dirección:'"
                      v-on="on"
                    >
                    </v-autocomplete>
                  </template>
                  <span>Bis</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="modelSelected.letra2"
                      label="Letra"
                      :rules="[rules.max(15, modelSelected.letra2)]"
                      :maxlength="15"
                      :counter="15"
                      @input="direccioncompleta()"
                      clearable
                      scrollable
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <span>C</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-tooltip top color="#B6332E">
                  <template v-slot:activator="{ on }">
                    <v-autocomplete
                      v-model="modelSelected.orientacion"
                      :items="orientacion"
                      item-value="Valor"
                      item-text="Descripcion"
                      color="primary"
                      @change="direccioncompleta()"
                      clearable
                      dense
                      :label="'Orientación Geográfica:'"
                      :hint="'Elija uno de las orientaciones de la dirección:'"
                      v-on="on"
                    >
                    </v-autocomplete>
                  </template>
                  <span>Sur</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <div class="text-center">
                  <v-chip
                    label
                    color="#B6332E"
                    text-color="white"
                    value="Vía Principal"
                  >
                    <v-avatar left>
                      <v-icon>mdi-map</v-icon>
                    </v-avatar>
                    <b> VÍA SECUNDARIA </b>
                  </v-chip>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <div class="text-center">
                  <v-chip
                    label
                    color="primary"
                    text-color="white"
                    value="Vía Principal"
                  >
                    <v-avatar left>
                      <v-icon>mdi-map</v-icon>
                    </v-avatar>
                    <b> VÍA COMPLEMENTO </b>
                  </v-chip>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="1" justify="center">
                <div class="text-center">
                  <v-chip
                    label
                    color="#B6332E"
                    text-color="white"
                    value="Vía Principal"
                  >
                    <b class="text-h3 mb-1"> # </b>
                  </v-chip>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-tooltip top color="#B6332E">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :label="'Número'"
                      type="tel"
                      v-on:keypress="isNumber()"
                      v-model.number="modelSelected.numero2"
                      :maxlength="4"
                      :counter="4"
                      @input="direccioncompleta()"
                      :rules="[rules.max(4, modelSelected.numero2)]"
                      :hint="'Ingrese solo números'"
                      clearable
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <span>55</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="modelSelected.letra3"
                      label="Letra"
                      :rules="[rules.max(15, modelSelected.letra3)]"
                      :maxlength="15"
                      :counter="15"
                      @input="direccioncompleta()"
                      clearable
                      scrollable
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <span>BA</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="1">
                <div class="text-center">
                  <v-chip
                    label
                    color="primary"
                    text-color="white"
                    value="Vía Principal"
                  >
                    <b class="text-h3 mb-1"> --- </b>
                  </v-chip>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :label="'Número'"
                      type="tel"
                      v-on:keypress="isNumber()"
                      v-model.number="modelSelected.numero3"
                      :maxlength="4"
                      :counter="4"
                      @input="direccioncompleta()"
                      :rules="[rules.max(4, modelSelected.numero3)]"
                      :hint="'Ingrese solo números'"
                      clearable
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <span>15</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-tooltip top color="#B6332E">
                  <template v-slot:activator="{ on }">
                    <v-autocomplete
                      v-model="modelSelected.orientacion2"
                      :items="orientacion"
                      item-value="Valor"
                      item-text="Descripcion"
                      color="primary"
                      @change="direccioncompleta()"
                      clearable
                      dense
                      :label="'Orientación Geográfica:'"
                      :hint="'Elija uno de las orientaciones de la dirección:'"
                      v-on="on"
                    >
                    </v-autocomplete>
                  </template>
                  <span>Sur</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="modelSelected.completo"
                  label="Dirección Nueva"
                  :rules="[rules.max(200, modelSelected.completo)]"
                  :maxlength="200"
                  :counter="200"
                  readonly
                  scrollable
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Complemte de Dirección -->
            <v-row align="center" justify="start" v-if="item.Tipo == 16">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h3 mb-1">
                    <b>Ingreso de Complemento: </b>
                  </v-list-item-title>
                  <span class="text-h5 mb-1">
                    Asistente para el ingreso de dirección complementaria. EJ:
                    (Apto 215 Int 13). Ingrese el complemento de la dirección
                    principal (de acuerdo al ejemplo) y de clic sobre el botón
                    <b> Guardar </b>.
                    <i>
                      (Seleccione el tipo de complemento en la lista desplegable
                      e ingrese el valor que complemente la descripción
                      seleccionada. Si lo desea, puede ingresar otro dato
                      complementario que considere correspondiente para la
                      dirección en el último recuadro. Recuerde verificar su
                      dirección en el recuadro inferior "Complemento")</i
                    >.</span
                  >
                </v-list-item-content>
              </v-list-item>
              <v-col cols="12" sm="12" md="3">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on }">
                    <v-autocomplete
                      v-model="modelSelected.prefijo3"
                      :items="Prefijo3"
                      item-value="Valor"
                      item-text="Descripcion"
                      color="primary"
                      @change="complementocompleta()"
                      clearable
                      dense
                      :label="'Tipo de Activo:'"
                      :hint="'Elija uno de los prefijos del complemento:'"
                      v-on="on"
                    >
                    </v-autocomplete>
                  </template>
                  <span>Apto. - Apartamento</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-tooltip top color="#B6332E">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="modelSelected.letra4"
                      label="Número/Letra"
                      @input="complementocompleta()"
                      :rules="[rules.max(10, modelSelected.letra4)]"
                      :maxlength="10"
                      :counter="10"
                      clearable
                      scrollable
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <span>410B</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on }">
                    <v-autocomplete
                      v-model="modelSelected.prefijo4"
                      :items="Prefijo3"
                      item-value="Valor"
                      item-text="Descripcion"
                      color="primary"
                      @change="complementocompleta()"
                      clearable
                      dense
                      :label="'Tipo de Activo:'"
                      :hint="'Elija uno de los prefijos del complemento:'"
                      v-on="on"
                    >
                    </v-autocomplete>
                  </template>
                  <span>Etapa</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-tooltip top color="#B6332E">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="modelSelected.letra5"
                      label="Número/Letra"
                      @input="complementocompleta()"
                      :rules="[rules.max(10, modelSelected.letra5)]"
                      :maxlength="10"
                      :counter="10"
                      clearable
                      scrollable
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <span>5A</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on }">
                    <v-autocomplete
                      v-model="modelSelected.prefijo5"
                      :items="Prefijo3"
                      item-value="Valor"
                      item-text="Descripcion"
                      color="primary"
                      @change="complementocompleta()"
                      clearable
                      dense
                      :label="'Tipo de Activo:'"
                      :hint="'Elija uno de los prefijos del complemento:'"
                      v-on="on"
                    >
                    </v-autocomplete>
                  </template>
                  <span>Par. - Parqueadero</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-tooltip top color="#B6332E">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="modelSelected.letra6"
                      label="Número/Letra"
                      @input="complementocompleta()"
                      :rules="[rules.max(10, modelSelected.letra6)]"
                      :maxlength="10"
                      :counter="10"
                      clearable
                      scrollable
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <span>25LL</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on }">
                    <v-autocomplete
                      v-model="modelSelected.prefijo6"
                      :items="Prefijo3"
                      item-value="Valor"
                      item-text="Descripcion"
                      color="primary"
                      @change="complementocompleta()"
                      clearable
                      dense
                      :label="'Tipo de Activo:'"
                      :hint="'Elija uno de los prefijos del complemento:'"
                      v-on="on"
                    >
                    </v-autocomplete>
                  </template>
                  <span>Torre</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-tooltip top color="#B6332E">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="modelSelected.letra7"
                      label="Número/Letra"
                      @input="complementocompleta()"
                      :rules="[rules.max(15, modelSelected.letra7)]"
                      :maxlength="15"
                      :counter="15"
                      clearable
                      scrollable
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <span>5</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="modelSelected.adicional"
                  label="Datos Adicionales"
                  :rules="[rules.max(200, modelSelected.adicional)]"
                  :maxlength="200"
                  :counter="200"
                  @input="complementocompleta()"
                  clearable
                  :hint="'Digite datos adicionales si los requiere, como por ejemplo: Conjunto'"
                  scrollable
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="modelSelected.complementocompleto"
                  label="Complemento  Nuevo"
                  :rules="[rules.max(300, modelSelected.complementocompleto)]"
                  :maxlength="300"
                  :counter="300"
                  readonly
                  scrollable
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import store from "@/store";
export default {
  name: "datepicker-modal",
  data() {
    return {
      item: this.infoCampo,
      modal: false,
      menu2: false,
      modal2: false,
      Prefijo: [],
      Prefijo2: [],
      Prefijo3: [],
      orientacion: [],
      modelSelected: {
        prefijo: "",
        prefijo2: "",
        prefijo3: "",
        prefijo4: "",
        prefijo5: "",
        prefijo6: "",
        numero1: 0,
        numero2: 0,
        numero3: 0,
        letra1: "",
        letra2: "",
        letra3: "",
        letra4: "",
        letra5: "",
        letra6: "",
        letra7: "",
        orientacion: "",
        orientacion2: "",
        adicional: "",
        completo: "",
        complementocompleto: "",
      },
      rules: {
        required(isRequired, v) {
          if (isRequired) {
            return !!v || "Este campo es obligatorio.";
          } else {
            return true;
          }
        },
        min(min, v) {
          return (
            (v.toString() || "").length >= min ||
            `Debes digitar minímo ${min} carácteres.`
          );
        },
        max(max, v) {
          return (
            (v.toString() || "").length <= max ||
            `No puedes digitar más de ${max} carácteres.`
          );
        },
      },
    };
  },
  props: {
    infoCampo: {
      type: Object,
      default: null,
      Description: "Información del campo tipo Datepicker para ser añadido",
    },
  },
  methods: {
    // Consulta todos los prefijos de direccion
    async getprefijo() {
      this.Prefijo = [];
      apiUtils
        .get("/seguridad/TablaSistema/CD1/SPE00030")
        .then((response) => {
          this.Prefijo = response.data;
        })
        .catch((e) => console.log(e));
    },

    // Consulta todos los prefijos de direccion
    async getprefijo2() {
      this.Prefijo2 = [];
      apiUtils
        .get("/seguridad/TablaSistema/CD1/SPE00031")
        .then((response) => {
          this.Prefijo2 = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta todos los prefijos de direccion
    async getcomplemento() {
      this.Prefijo3 = [];
      apiUtils
        .get("/seguridad/TablaSistema/CD1/SPE00033")
        .then((response) => {
          this.Prefijo3 = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta todos los prefijos de direccion
    async getorientacion() {
      this.orientacion = [];
      apiUtils
        .get("/seguridad/TablaSistema/CD1/SPE00032")
        .then((response) => {
          this.orientacion = response.data;
        })
        .catch((e) => console.log(e));
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    direccioncompleta() {
      this.modelSelected.completo = "";
      if (
        this.modelSelected.prefijo != "" &&
        this.modelSelected.prefijo != undefined &&
        this.modelSelected.prefijo != null
      ) {
        this.modelSelected.completo = this.modelSelected.prefijo;
      }
      if (
        this.modelSelected.numero1 > 0 &&
        this.modelSelected.numero1 != undefined &&
        this.modelSelected.numero1 != null
      ) {
        this.modelSelected.completo += " " + this.modelSelected.numero1;
      }
      if (
        this.modelSelected.letra1 != "" &&
        this.modelSelected.letra1 != undefined &&
        this.modelSelected.letra1 != null
      ) {
        this.modelSelected.completo +=
          " " + this.modelSelected.letra1.toUpperCase().replace(/ /g, "");
      }
      if (
        this.modelSelected.prefijo2 != "" &&
        this.modelSelected.prefijo2 != undefined &&
        this.modelSelected.prefijo2 != null
      ) {
        this.modelSelected.completo += " " + this.modelSelected.prefijo2;
      }
      if (
        this.modelSelected.letra2 != "" &&
        this.modelSelected.letra2 != undefined &&
        this.modelSelected.letra2 != null
      ) {
        this.modelSelected.completo +=
          " " + this.modelSelected.letra2.toUpperCase().replace(/ /g, "");
      }
      if (
        this.modelSelected.orientacion != "" &&
        this.modelSelected.orientacion != undefined &&
        this.modelSelected.orientacion != null
      ) {
        this.modelSelected.completo += " " + this.modelSelected.orientacion;
      }
      if (
        this.modelSelected.numero2 > 0 &&
        this.modelSelected.numero2 != undefined &&
        this.modelSelected.numero2 != null
      ) {
        this.modelSelected.completo += " # " + this.modelSelected.numero2;
      }
      if (
        this.modelSelected.letra3 != "" &&
        this.modelSelected.letra3 != undefined &&
        this.modelSelected.letra3 != null
      ) {
        this.modelSelected.completo +=
          " " + this.modelSelected.letra3.toUpperCase().replace(/ /g, "");
      }
      if (
        this.modelSelected.numero3 > 0 &&
        this.modelSelected.numero3 != undefined &&
        this.modelSelected.numero3 != null
      ) {
        this.modelSelected.completo += " - " + this.modelSelected.numero3;
      }
      if (
        this.modelSelected.orientacion2 != "" &&
        this.modelSelected.orientacion2 != undefined &&
        this.modelSelected.orientacion2 != null
      ) {
        this.modelSelected.completo += " " + this.modelSelected.orientacion2;
      }
      if (
        this.modelSelected.completo != null &&
        this.modelSelected.completo != "" &&
        this.modelSelected.completo != undefined
      ) {
        this.modelSelected.completo = this.modelSelected.completo
          .trim()
          .substring(0, 200);
      }
    },

    complementocompleta() {
      this.modelSelected.complementocompleto = "";
      if (
        this.modelSelected.prefijo3 != "" &&
        this.modelSelected.prefijo3 != undefined &&
        this.modelSelected.prefijo3 != null
      ) {
        this.modelSelected.complementocompleto = this.modelSelected.prefijo3;
      }
      if (
        this.modelSelected.letra4 != "" &&
        this.modelSelected.letra4 != undefined &&
        this.modelSelected.letra4 != null
      ) {
        this.modelSelected.complementocompleto +=
          " " + this.modelSelected.letra4.toUpperCase().replace(/ /g, "");
      }
      if (
        this.modelSelected.prefijo4 != "" &&
        this.modelSelected.prefijo4 != undefined &&
        this.modelSelected.prefijo4 != null
      ) {
        this.modelSelected.complementocompleto +=
          " " + this.modelSelected.prefijo4;
      }
      if (
        this.modelSelected.letra5 != "" &&
        this.modelSelected.letra5 != undefined &&
        this.modelSelected.letra5 != null
      ) {
        this.modelSelected.complementocompleto +=
          " " + this.modelSelected.letra5.toUpperCase().replace(/ /g, "");
      }
      if (
        this.modelSelected.prefijo5 != "" &&
        this.modelSelected.prefijo5 != undefined &&
        this.modelSelected.prefijo5 != null
      ) {
        this.modelSelected.complementocompleto +=
          " " + this.modelSelected.prefijo5;
      }
      if (
        this.modelSelected.letra6 != "" &&
        this.modelSelected.letra6 != undefined &&
        this.modelSelected.letra6 != null
      ) {
        this.modelSelected.complementocompleto +=
          " " + this.modelSelected.letra6.toUpperCase().replace(/ /g, "");
      }
      if (
        this.modelSelected.prefijo6 != "" &&
        this.modelSelected.prefijo6 != undefined &&
        this.modelSelected.prefijo6 != null
      ) {
        this.modelSelected.complementocompleto +=
          " " + this.modelSelected.prefijo6;
      }
      if (
        this.modelSelected.letra7 != "" &&
        this.modelSelected.letra7 != undefined &&
        this.modelSelected.letra7 != null
      ) {
        this.modelSelected.complementocompleto +=
          " " + this.modelSelected.letra7.toUpperCase().replace(/ /g, "");
      }
      if (
        this.modelSelected.adicional != "" &&
        this.modelSelected.adicional != undefined &&
        this.modelSelected.adicional != null
      ) {
        this.modelSelected.complementocompleto +=
          " - " + this.modelSelected.adicional.toUpperCase();
      }
      if (
        this.modelSelected.complementocompleto != null &&
        this.modelSelected.complementocompleto != "" &&
        this.modelSelected.complementocompleto != undefined
      ) {
        this.modelSelected.complementocompleto =
          this.modelSelected.complementocompleto.trim().substring(0, 200);
      }
    },

    clear() {
      this.modelSelected.completo = "";
      this.modelSelected.complementocompleto = "";
      this.modelSelected.prefijo = "";
      this.modelSelected.numero1 = 0;
      this.modelSelected.prefijo2 = "";
      this.modelSelected.letra2 = "";
      this.modelSelected.orientacion = "";
      this.modelSelected.numero2 = 0;
      this.modelSelected.letra3 = "";
      this.modelSelected.numero3 = 0;
      this.modelSelected.orientacion2 = "";
      this.modelSelected.prefijo3 = "";
      this.modelSelected.prefijo4 = "";
      this.modelSelected.prefijo5 = "";
      this.modelSelected.prefijo6 = "";
      this.modelSelected.letra4 = "";
      this.modelSelected.letra5 = "";
      this.modelSelected.letra6 = "";
      this.modelSelected.letra7 = "";
    },
  },

  mounted() {
    this.getprefijo();
    this.getprefijo2();
    this.getorientacion();
    this.getcomplemento();
    this.clear();
  },
};
</script>
